import { FirebaseDataService } from "../../../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export function fetchGraphSessionDistribution(statusObj, user, graph) {
  return new Promise(async (resolve, reject) => {
    try {
        firebaseDataService.getStats(statusObj,user, graph, "noncadenceBarchart").subscribe((data) => {
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}